<template>
    <div class="rechargehour">
        <div class="hourBox">
            <span class="text">前</span>
            <el-select v-model="form.hourInfo.totalRankCount" placeholder="请选择" @change="hourChange">
                <el-option :label="item" :value="item" v-for="item in form.hourInfo.hourList" :key="item"></el-option>
            </el-select>
            <span class="text">名奖励</span>
        </div>
        <div class="hourBox" v-for="(item,index) in hourList" :key="index">
            <span class="text">第</span>
            <div class="box">{{ index + 1 }}</div>
            <span class="text">名奖励</span>
            <div>
                <el-select v-model="item.coupons" placeholder="请选择">
                    <el-option :label="j.label" :value="j.value" v-for="j in item.couponsNumList" :key="j.value" @click.native="couponsChange(item,j)"></el-option>
                </el-select>
            </div>
            <div>
                <el-select v-model="item.couponName" placeholder="请选择">
                    <el-option :label="i.couponName" :value="i.couponId" v-for="i in item.give" :key="i.couponId" @click.native="couponsTypeClick(item,i)"></el-option>
                </el-select>
            </div>
            <span class="text">元</span>
        </div>
    </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
    data () {
        return {
            radioNum: null,
            billiardsId: JSON.parse(this.$store.state.billiardsInfo).billiardsId,  //商户id
            hourList: [
                {
                    couponsType: null,
                    coupons: null,
                    rank: 1,
                    couponsNumList: [
                        {
                            value: 2,
                            label: '水机券',
                        },
                        {
                            value: 1,
                            label: '台费券',
                        },
                    ],
                    give: []
                }
            ],
            totalRankCount: 0,
            give: [],
            hourGiveInfo: {},
            couponsNumList: [
                {
                    value: 2,
                    label: '水机券',
                },
                {
                    value: 1,
                    label: '台费券',
                },
            ],
        }
    },
    props: ['form', 'addType'],
    methods: {
        async getInit (items, val) {
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: val.value,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const data = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            if (data.list.length > 0) {
                this.$set(items, 'give', data.list)
                // items.give = data.list
            }
        },
        hourChange (e) {
            let ary = []
            this.hourList.map(item => {
                ary.push(item)
            })
            let num = e - this.hourList.length
            if (num > 0) {
                for (var i = 0; i < num; i++) {
                    let obj = {
                        rank: '',
                        couponsType: null,
                        coupons: null,
                        couponName: '',
                        couponUseScopeType: '',
                        couponsNumList: [
                            {
                                value: 2,
                                label: '水机券',
                            },
                            {
                                value: 1,
                                label: '台费券',
                            },
                        ],
                        give: []
                    }
                    ary.push(obj)
                }
            } else {
                num = num * -1
                for (var i = 0; i < num; i++) {
                    ary.splice(-1);
                }
            }
            this.hourList = ary
        },
        couponsChange (item, val) {
            this.$set(item, 'couponName', '')
            this.$set(item, 'couponId', '')
            this.$set(item, 'give', [])
            item.couponUseScopeType = val.value
            this.getInit(item, val)
        },
        couponsTypeClick (item, j) {
            item.couponId = j.couponId
            item.couponName = j.couponName
            item.couponUseScopeType = j.useScopeType
        },
        async configFn (close) {
            let array = []
            this.hourList.map((item, index) => {
                let give = []
                let giveInfo = {
                    couponId: item.couponId,
                    couponName: item.couponName,
                    couponUseScopeType: item.couponUseScopeType,
                    couponNum: 1
                }
                give.push(giveInfo)
                let obj = {
                    rank: index + 1,
                    give: give
                }
                array.push(obj)
            })
            console.log(array);
            let params = {
                billiardsId: this.billiardsId,
                id: this.form.activityId,
                name: this.form.name,
                remark: this.form.remark,
                status: null,
                templateType: this.form.type,
                startTime: this.form.creatDate,
                endTime: this.form.endDate,
                ruleConfig: {
                    rule: array,
                    totalRankCount: this.form.hourInfo.totalRankCount
                },
            }
            console.log(params, 'params');
            const data = await response(requstsMethod.fun_service_authorized_activity_task_save, params)
            if (data.pass) {
                this.$message({ message: `${this.addType == 'add' ? '添加' : '修改'}成功`, type: 'success' });
                close()
            } else {
                this.$message({ message: `${this.addType == 'add' ? '添加' : '修改'}失败，${data.errorLine[0].prompt}`, type: 'error' });
            }
        },
        getClear () {
            this.form.creatDate = ''
            this.form.endDate = ''
            this.form.hourInfo.totalRankCount = 1
        }
    }
}
</script>

<style lang="scss">
.rechargehour {
    .hourBox {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 15px;
        margin: 20px 0;
        .box {
            width: 30px;
            height: 30px;
            text-align: center;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 1px;
            display: inline-block;
            box-shadow: 0 0 5px #000 inset;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 0 0 10px;
        }
        .text {
            height: 30px;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 1px;
            display: inline-block;
            margin-left: 10px;
            display: flex;
            align-items: center;
        }
        .el-select {
            width: 260px;
            margin: 0 10px;
            .el-input__inner {
                height: 40px;
                line-height: 40px;
                color: #fff;
                border: none;
                background-color: #3e3e3e;
                box-shadow: 0 0 5px #000 inset;
            }
        }
    }
}
</style>